import React, { useEffect, useRef, useState } from "react";
import useToggle from "hooks/useToggle";

const ReadMore = ({ children }) => {
	const [isExpanded, toggleIsExpanded] = useToggle(false);
	const [showButton, setShowButton] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			setShowButton(ref.current.scrollHeight !== ref.current.clientHeight);
		}
	}, []);

	return (
		<div>
			<div className={isExpanded ? "line-clamp-none" : "line-clamp-2 max-h-12"} ref={ref}>
				{children}
			</div>
			{showButton &&
				<button onClick={toggleIsExpanded} className="underline pt-2">
					{isExpanded ? "Read less" : "Read more"}
				</button>
			}
		</div >
	);
};
export default ReadMore;